import ESuranceInvoiceAddressModelBase from '../_generated/modelBases/e-surance-invoice-address-model-base';

export default class ESuranceInvoiceAddressModel extends ESuranceInvoiceAddressModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
